var reality = new function () {
    this.sizes = {
        xl: 1200,
        lg: 992,
        md: 768,
        sm: 320,
        xs: 0
    };
    this.xhr;
    this.currentCurrency = 'gbp';
    this.currentCurrencyRate = 1;
    this.currentCurrencySymbol = '£';
    this.doToggleCurrencyDropdown = function (event, el) {
        $('#currency-dropdown').toggle();
    };
    this.setHeader = function () {
        if (typeof this.xhr == 'object') this.xhr.abort();
        this.xhr = $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: {
                action: 'get_cart_total',
                get_currency: true,
                _wpnonce: $('#header-cart').data('nonce')
            },
            success: function (json) {
                reality.setCurrencyUi(json.data.currency);
                if (json.data.count > 0) {
                    $('#header-cart-count').removeClass('hide').text(json.data.count);
                    $('#header-cart-total').text(json.data.total);
                }
                reality.currentCurrencyRate = json.data.rate;
                reality.currentCurrencySymbol = json.data.symbol;
                reality.doReplaceCurrencies();
            }
        });
    };
    this.setKlaviyoOff = function() {
        var optanonConsentCookie = reality.getCookie('OptanonConsent');
        var optanonCookieGroupRegex = /.*C0004:1.*/;
        if (optanonConsentCookie && optanonConsentCookie.match(optanonCookieGroupRegex)) {
            document.cookie = "__kla_off=''; expires = Thu, 01 Jan 1970 00:00:00 GMT;";
            // document.cookie = "__kla_id=12345;"; // debug
        } else {
            if(!reality.getCookie('__kla_off')) {
                document.cookie = "__kla_off=true";
            }
            document.cookie = "__kla_id=''; expires=Thu, 01 Jan 1970 00:00:00 GMT;";
        }
    };
    this.getCookie = function (cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    this.setCurrencyUi = function (currency) {
        var $selectedCurrency = $('#currency-selector-' + currency),
            $selectedCurrencyTitle = $('#currency-selector-' + currency + '-title');
        reality.currentCurrency = currency;
        $('#currency-dropdown').find('li').removeClass('header-top__currency-dropdown-item--selected');
        $selectedCurrency.addClass('header-top__currency-dropdown-item--selected');

        $('#currency-flag').attr('src', '/images/' + currency + '.png').addClass('header-top__currency-flag').attr('id', 'currency-flag');
        $('#currency-title').html($selectedCurrencyTitle.text().trim());
    };
    this.doSelectCurrency = function (event, el) {
        var currency = $(el).data('currency'),
            isWooCheckout = $('body').hasClass('woocommerce-cart') || $('body').hasClass('woocommerce-checkout');
        if (currency != reality.currentCurrency) {
            //if (!isWooCheckout) {
                reality.setCurrencyUi(currency);
                reality.currentCurrencyRate = $(el).data('currencyRate');
                reality.currentCurrencySymbol = $(el).data('currencySymbol');
                reality.doToggleCurrencyDropdown(null, null);
                reality.doReplaceCurrencies();
            //}
            if (typeof this.xhr == 'object') this.xhr.abort();
            this.xhr = $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: {
                    action: 'set_currency',
                    currency: currency,
                    nonce: $('#currency-button').data('nonce')
                }/*,
                success: function (json) {
                    if (isWooCheckout) {
                        document.location = '';
                    }
                }*/
            });
        }
    };
    this.doReplaceCurrencies = function () {
        var number;
        $('.reality-currency-only')[(reality.currentCurrency == 'gbp' ? 'add' : 'remove') + 'Class']('hide');
        $('.reality-currency-name').html(reality.currentCurrency.toUpperCase());
        $('.reality-currency').each(function () {
            if ($(this).attr('data-original-number')) {
                number = parseFloat($(this).attr('data-original-number'));
            } else {
                number = parseFloat($(this).text().replace(/[^0-9.]/g, ''));
                if (!isNaN(number)) {
                    $(this).attr('data-original-number', number);
                }
            }
            if (!isNaN(number)) {
                $(this).html(reality.currentCurrencySymbol.toString() + format.number((number * reality.currentCurrencyRate)));
            } else if (number.length > 0) {
                console.info('Failed to replace', $(this));
            }
        });
    };
    this.getBackground = function ($background, windowWidth) {
        var backgroundImage = '';
        $.each(reality.sizes, function (breakPoint, minSize) {
            if (windowWidth >= minSize && $background.data(breakPoint)) {
                backgroundImage = $background.data(breakPoint);
                return false;
            }
        });
        return backgroundImage;
    };
    this.setMediaBackground = function () {
        if ($('.reality-media-background').length) {
            var windowWidth = $(window).width(),
                backgroundSet = false,
                backgroundImage,
                $backgroundElement;
            $('.reality-media-background').each(function() {
                $backgroundElement = $(this);
                backgroundSet = false;
                if (data.isVisible($backgroundElement) && $backgroundElement.is(':visible')) {
                    $.each(reality.sizes, function (breakPoint, minSize) {
                        if (windowWidth >= minSize) {
                            backgroundImage = reality.getBackground($backgroundElement, windowWidth);
                            if (backgroundImage) {
                                $backgroundElement.css('background-image', 'url(\'' + backgroundImage + '\')');
                                backgroundSet = true;
                                return false;
                            }
                        }
                    });
                    if (!backgroundSet) {
                        $.each(reality.sizes, function (breakPoint, minSize) {
                            if (typeof $backgroundElement.data(breakPoint) != 'undefined') {
                                backgroundImage = $backgroundElement.data(breakPoint);
                                if (backgroundImage) {
                                    $backgroundElement.css('background-image', 'url(\'' + backgroundImage + '\')');
                                }
                            }
                        });
                    }
                }
            });
        }
    };
    this.setLazyLoadedImages = function () {
        $('.reality-lazy-load:not(.reality-lazy-loaded), img[data-srcset]').each(function() {
            var $el = $(this),
                newSrc = $el.data('imageSrc');
            if (data.isVisible($el, 50) && $el.is(':visible')) {
                if ($el.data('srcset')) {
                    newSrc = reality.getSrcSetImage($el);
                }
                if ($el.is('img')) {
                    $el.attr('src', newSrc);
                } else {
                    $el.css('backgroundImage', 'url(' + newSrc + ')');
                }
            }
        });
    };
    this.setLazyCarouselImages = function () {
        $('.reality-lazy-load-carousel:not(.reality-lazy-loaded-carousel)').each(function() {
            var $el = $(this),
                newSrc = $el.data('imageSrc');
            if (data.isVisible($el, 50) && $el.is(':visible')) {
                $el.css('backgroundImage', 'url(' + newSrc + ')').addClass('reality-lazy-loaded-carousel');
            }
        });
    };
    this.doToggleFooterContent = function (event, el) {
        if ($(window).width() < 575) {
            var $container = $(el).closest('div'),
                $content = $container.find('.footer-upper__content');
            $container.find('.footer-upper__content-toggler svg').toggleClass('hide');
            $content.slideToggle(200);
        }
    };
    this.doQuantityChange = function (event, el) {
        var $quantity = $(el).closest('.quantity'),
            $input = $quantity.find('.input-text'),
            min = ($input.attr('min') ? parseInt($input.attr('min')) : 0),
            max = ($input.attr('max') ? parseInt($input.attr('max')) : 0),
            quantity = parseInt($input.val()),
            direction = ($(el).hasClass('quantity-button--minus') ? '-' : '+');
        if (!$(el).hasClass('quantity-button--disabled')) {
            if (direction == '+') {
                quantity ++;
                if (max > 0 && quantity > max) quantity = max;
            } else {
                quantity --;
                if (quantity < min) quantity = min;
            }
            $input.val(quantity);
            $quantity.find('.quantity-button--minus')[(quantity <= min ? 'add' : 'remove') + 'Class']('quantity-button--disabled');
            $quantity.find('.quantity-button--plus')[(max > 0 && quantity >= max ? 'add' : 'remove') + 'Class']('quantity-button--disabled');

            if ($('form.cart').find('input.qty').length) {
                products.setQuantityPrice();
            }

            if ($('.woocommerce-cart-form').length) {
                $('button[name="update_cart"]').prop('disabled', false);
                clearTimeout(reality.cartQuantityTimeout);
                reality.cartQuantityTimeout = setTimeout(function () {
                    if (!$('.woocommerce-cart-form').hasClass('processing')) {
                        $('button[name="update_cart"]').trigger('click');
                    }
                }, 600);
            }
        }
    };
    this.setQuantityChanged = function (event, el) {
        var $quantity = $(el).closest('.quantity'),
            $input = $quantity.find('.input-text'),
            min = ($input.attr('min') ? parseInt($input.attr('min')) : 0),
            max = ($input.attr('max') ? parseInt($input.attr('max')) : 0),
            quantity = parseInt($input.val());
        if (quantity < min) {
            $input.val(min);
        }
        if (max > 0 && quantity > max) {
            $input.val(max);
        }
        $quantity.find('.quantity-button--minus')[(quantity <= min ? 'add' : 'remove') + 'Class']('quantity-button--disabled');
        $quantity.find('.quantity-button--plus')[(max > 0 && quantity >= max ? 'add' : 'remove') + 'Class']('quantity-button--disabled');

        if ($('form.cart').find('input.qty').length) {
            products.setQuantityPrice();
        }
    };
    this.getImageWidthNeeded = function ($image) {
        var renderWidth = $image.closest('.col').width();
        if (renderWidth == 0) {
            renderWidth = $image.closest('figure').width();
        }
        if (renderWidth == 0) {
            renderWidth = $(window).width();
        }
        return renderWidth;
    };
    this.getSrcSetImage = function ($image) {
        var images = $image.data('srcset').split(','),
            renderWidth = this.getImageWidthNeeded($image),
            imageArray,
            imageSrc,
            imageSizes = {};
        //console.log($image, renderWidth);
        $.each(images, function (i, image) {
            imageArray = image.trim().split(' ');
            imageSizes[parseInt(imageArray[1].replace('w', ''))] = imageArray[0];
        });
        $.each(imageSizes, function (size, imagePath) {
            if (size > renderWidth) {
                imageSrc = imagePath;
                return false;
            }
            imageSrc = imagePath;
        });
        return imageSrc;
    };
    this.setSlickInit = function ($element, event, slick) {
        if (typeof $element.data('slickPageNumber') != 'undefined') {
            $element.before('<div class="slick-page-number"></div>');
            var $pageNumber = $element.parent().find('.slick-page-number');
            if ($pageNumber.length) {
                var totalPages = Math.ceil(slick.slideCount / slick.slickGetOption('slidesToShow'));
                if (totalPages > 1) {
                    $pageNumber.html('<span class="current">1</span>/' + totalPages);
                } else {
                    $pageNumber.html('');
                }
            }
        }
    };
    this.setSlickBeforeChange = function ($element, event, slick, currentSlide, nextSlide) {
        var $pageNumber = $element.parent().find('.slick-page-number');
        if ($pageNumber.length) {
            var totalPages = Math.ceil(slick.slideCount / slick.slickGetOption('slidesToShow')),
                pageNumber = (nextSlide / slick.slickGetOption('slidesToShow')) + 1;
            if (totalPages > 1) {
                $pageNumber.html('<span class="current">' + pageNumber + '</span>/' + totalPages);
            } else {
                $pageNumber.html('');
            }
        }
    };
    this.toggleContactForm = function(el) {
        $(el.target).closest('button').toggleClass('btn-primary btn-outline-primary').find('.status svg').toggleClass('hide');
        $(".contact-page__form").animate({
            height: "toggle",
            opacity: "toggle",
            padding: "toggle"
        }, "slow");
    };
    this.displayPreviousAddresses = function () {
        $('#previous_billing_address select, #previous_shipping_address select').select2();
        jQuery(document).ready(function ($) {

            if ($('#previous_billing_address').length) {
                $('#billing_country_field').before($('#previous_billing_address'));
            }
            if ($('#previous_shipping_address').length) {
                $('#shipping_country_field').before($('#previous_shipping_address'));
            }
        });
        $('#billing_dropdown').click(function () {
            $('#billing_select').show();
            $(this).hide();
            $('#billing_cancel').show();
        });

        $('#billing_cancel').click(function () {
            $('#billing_select').hide();
            $(this).hide();
            $('#billing_dropdown').show();
        });
        $('#previous_billing_address select').on('change', function () {
            if (this.value === '') {
                return; // Exit if default option selected
            }
            var address = JSON.parse($(this).val());
            $('#billing_address_1').val(address.address_1);
            $('#billing_address_2').val(address.address_2);
            $('#billing_city').val(address.city);
            $('#billing_state').val(address.state);
            $('#billing_postcode').val(address.postcode);
        });
        $('#shipping_dropdown').click(function () {
            $('#shipping_select').show();
            $(this).hide();
            $('#shipping_cancel').show();
        });

        $('#shipping_cancel').click(function () {
            $('#shipping_select').hide();
            $(this).hide();
            $('#shipping_dropdown').show();
        });
        $('#previous_shipping_address select').on('change', function () {
            if (this.value === '') {
                return; // Again, exit if default option selected
            }
            var address = JSON.parse($(this).val());
            $('#shipping_address_1').val(address.address_1);
            $('#shipping_address_2').val(address.address_2);
            $('#shipping_city').val(address.city);
            $('#shipping_state').val(address.state);
            $('#shipping_postcode').val(address.postcode);
        });
    };
    this.displayDeliveryDate = function() {
        var deliveryDate = $('input[type=hidden][name=delivery_date]'),
            html = '';
        if(deliveryDate.length) {
            html += '<p><strong>Selected delivery date: </strong> ' + deliveryDate.val();
            html += ' (<a href="" class="change-delivery-date">Change Delivery Date</a>)' + '</p>';
            $('.selected-delivery-date').html(html);
        }
    };
    this.setCheckoutDatePicker = function () {
        var checkoutCalendar = $('.checkout-delivery-date');
        if (checkoutCalendar.length) {
            var excluded = checkoutCalendar.data('excluded').split(',');
            checkoutCalendar.datepicker({
                dateFormat: 'dd-mm-yy',
                minDate : 0,
                onSelect: function (date) {
                    var formattedDate = encodeURI(date).split('-');
                    $('input[name=delivery_date]').val(formattedDate[2]+'-'+formattedDate[1]+'-'+formattedDate[0]);
                    reality.displayDeliveryDate();
                    checkoutCalendar.fadeOut();
                },
                beforeShowDay: function(date){
                    var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
                    //return [ array.indexOf(string) == -1 ]
                    return excluded.indexOf(string) != -1 ? [false] : $.datepicker.noWeekends(date);
                }
            });
        }
    };
};

$(document).on('click', '.onetrust-close-btn-handler', function(e) {
    reality.setKlaviyoOff();
});

$(document).on('click', '.woocommerce-checkout .checkout-step a.change-delivery-date', function(e) {
    e.preventDefault();
    $('.checkout-delivery-date').fadeToggle();
});

$(document).on('click', '.woocommerce-checkout .checkout-step summary', function(e) {
    e.preventDefault();
});

$(document).on('keyup', '.woocommerce-cart-form .quantity input[type=number]', function(e) {
    $('button[name="update_cart"]').prop('disabled', false);
    clearTimeout(reality.cartQuantityTimeout);
    reality.cartQuantityTimeout = setTimeout(function () {
        if (!$('.woocommerce-cart-form').hasClass('processing')) {
            $('button[name="update_cart"]').trigger('click');
        }
    }, 600);
});

$(document).on('click', function(event){
    if (!$(event.target).closest('.header-top__currency').length) {
        $('#currency-dropdown').slideUp(200);
    }
});
$(document).ready(function() {
    setTimeout(function () {
        if(reality.getCookie('realityCurrency') && reality.getCookie('realityCurrency') !== 'gbp') {
            reality.setHeader();
        }
        reality.setMediaBackground();
        reality.setLazyLoadedImages();
        $('.loading').removeClass('visible');
    }, 100);

    $(window).on('load', function(){
        var href = window.location.href;
        if(href.indexOf('/checkout') > -1){
            setTimeout(function(){			
                $('.kl_newsletter_checkbox_field').insertAfter($('.woocommerce-terms-and-conditions'));
            }, 2000);
        }
    });

    $(window).on('resize orientationChange scroll', function() {
        reality.setLazyLoadedImages();
        data.doInitialiseSlickCarousels();
        reality.setMediaBackground();
    });

    if($('body.woocommerce-checkout').length) {
        reality.displayDeliveryDate();
        reality.setCheckoutDatePicker();
        reality.displayPreviousAddresses();
    }
    
    var OABCcookieName = "OptanonAlertBoxClosed";
    var OABCcookie = reality.getCookie(OABCcookieName);
        
    // IF logic needed here because ot-banner-sdk DIV is not injected on page loads if banner is not exposed
    if (!OABCcookie) {
        $(document).on('click', '#onetrust-accept-btn-handler', function() {
            // console.log("Allowed all via Banner");
            reality.setKlaviyoOff();
            $('.save-preference-btn-handler').trigger('click');
        });
    }
    $(document).on('click', '#accept-recommended-btn-handler', function() {
        // console.log("Allowed all via Preference Center");
        reality.setKlaviyoOff();
        $('.save-preference-btn-handler').trigger('click');
    });

    $(document).on('click', '.save-preference-btn-handler', function() {
        // console.log("Set custom settings via Preference Center");
        reality.setKlaviyoOff();
        setTimeout(()=> {
            var url = new URL(window.location.href);
            url.searchParams.set('cookies-accepted', '1');
            window.location.href = url.href;
            // location.reload();
        }, 500) //quick timeout so that the consent receipt can be sent and the cookie can be updated
    });
});

setTimeout(function () {
    reality.setKlaviyoOff();
}, 1500);

var format = new function () {
    this.number = function (number, decimals, thousands_point) {
        if (number == null || !isFinite(number)) {
            throw new TypeError('number is not valid');
        }
        if (typeof decimals == 'undefined') {
            decimals = 2;
        }
        if (typeof thousands_point == 'undefined') {
            thousands_point = ',';
        }
        number = parseFloat(number).toFixed(decimals);

        var split_number = number.split('.');
        split_number[0] = split_number[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
        if (split_number[1]) {
            if (split_number[1].length < decimals) {
                split_number[1] += '0'.repeat(decimals);
            }
        } else {
            split_number[1] = '0'.repeat(decimals);
        }
        number = split_number.join('.');
        return number;
    };
    this.round = function (number) {
        return Math.round((number + Number.EPSILON) * 100) / 100;
    };
};
var printLoaded = false;
window.onbeforeprint = function(event) {

    if (!printLoaded) {
        $('head').append('<link href="/css/print.css" rel="stylesheet" media="print" />');
    }
};